'use client';

import React from 'react';
import { Button, Card } from '@ui';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  openBtnRef?: React.RefObject<HTMLButtonElement | null>;
  label?: React.ReactNode;
  className?: string;
};

const AsideCollapseFromMain = ({
  open,
  onOpenChange,
  openBtnRef,
  className,
  label = '☰ Menu',
}: Props) => (
  <Card className={`main-head${className ? ' ' + className : ''}`}>
    <Button
      id='aside-expander'
      as='button'
      label={label}
      className='btn-ghost'
      ref={openBtnRef}
      onClick={() => onOpenChange(!open)}
      aria-expanded={open}
    />
  </Card>
);

export default AsideCollapseFromMain;
